import { useTranslation } from 'react-i18next';
import { ExportIcon } from '@phosphor-icons/react';
import { SelectionBar as SharedSelectionBar } from '@/components';
import { ActionType } from '@/components/ActionBar';
import type { ActionConfig } from '@/components/ActionBar';
import { useQueryResultsStore } from '@/stores';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface SelectionBarProps {
    visibleEventIds: string[];
    exportBusy: boolean;
    onExport: () => Promise<void>;
    bulkActions: ActionConfig[];
}

export function SelectionBar({
    visibleEventIds,
    exportBusy,
    onExport,
    bulkActions,
}: SelectionBarProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);
    const exitSelectionMode = useQueryResultsStore(
        (state) => state.exitSelectionMode,
    );
    const selectedEventIds = useQueryResultsStore(
        (state) => state.selectedEventIds,
    );
    const selectAll = useQueryResultsStore((state) => state.selectAll);
    const clearSelection = useQueryResultsStore(
        (state) => state.clearSelection,
    );
    const loadedCount = visibleEventIds.length;
    const allLoadedSelected =
        loadedCount > 0 && selectedEventIds.size === loadedCount;

    const exportAction: ActionConfig = {
        type: ActionType.ITEM,
        icon: ExportIcon,
        label: t('selection.export'),
        disabled: exportBusy,
        onClick: () => void onExport(),
    };

    return (
        <SharedSelectionBar
            selectedCount={selectedEventIds.size}
            totalCount={loadedCount}
            entityLabel={t('pageTitle.events')}
            onSelectAll={() =>
                allLoadedSelected
                    ? clearSelection()
                    : selectAll(visibleEventIds)
            }
            onExitMultiSelect={exitSelectionMode}
            bulkActions={[...bulkActions, exportAction]}
        />
    );
}
